import React from 'react';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import { classes } from './Body.st.css';
import { ServiceCard } from './ServiceCard/ServiceCard';
import { EmptyState } from './EmptyState/EmptyState';

// A single DOM structure serves all layouts (grid, list, side-by-side,
// on-image). layoutType is a style param and can differ per breakpoint,
// so layout differences must be expressed purely through CSS vars emitted
// by customCssVars — never by branching in TypeScript.
export const Body = () => {
  const {
    bodyViewModel: { services },
  } = useWidgetViewModel();

  return (
    <div className={classes.root}>
      {services.length === 0 && <EmptyState />}
      <ul className={classes.list} data-hook="services-layout">
        {services.map((service, index) => (
          <li className={classes.item} key={service.id}>
            <ServiceCard
              service={service}
              index={index}
              even={index % 2 === 0}
            />
            <div className={classes.overlay} data-hook="on-image-overlay" />
          </li>
        ))}
      </ul>
    </div>
  );
};
